import modalConfirmation from '../shared/components/modal-response/modal-response.view.html';


let inject = [
    '$scope',
    'ResponseService',
    '$state',
    '$rootScope',
    'SharedService',
    '$uibModal',
    '$stateParams',
    '$window',
    'OrdersService'
];

class PayResponseController {
    constructor($scope, ResponseService, $state, $rootScope, SharedService, $uibModal, $stateParams,$window,OrdersService) {
        this.$state = $state;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$uibModal = $uibModal;
        this.$stateParams = $stateParams;
        this.ResponseService = ResponseService;
        this.SharedService = SharedService;
        this.$window = $window;
        this.loading = true;
        this.payInfo = {};
        this.alreadySend = false;
        this.orderInfo = {};
        this.OrdersService = OrdersService;
    }

    $onInit() {
        this.getResponse();
    }

    getResponse() {

        this.ResponseService.getResponse(this.$stateParams.auth).then(({data}) => {
            this.payInfo = data;
            this.orderInfo["id"] = this.payInfo.id;
            this.orderInfo["experience_comment"] = this.payInfo.experiencia_usuario_comentario;
            this.orderInfo["experience_rating"] = this.payInfo.experiencia_usuario_calificacion;

            this.loading=false;

        }).catch(reason => {
            alert("error");
        })
    }

    payNow() {

        let globals = this.shCtrl.globals;
        let userId = '';
        try {
            userId = globals.currentUser.userId;
        } catch (e) {}

        this.OrdersService.recalculateOrder(this.payInfo.pedidos_id, userId).then(response => {

            if(!response.error){

                if(response.order.estado_pago =="Procesando pago" || response.order.estado_pago =="Pagada"){
                    let options = {
                        title: '',
                        isHtml: true,
                        content: "No es posible realizar el pago de tu pedido. Es posible que el pago del pedido esté en proceso o ya haya sido aprobado, por favor dirígete al listado de tus pedidos.",
                        size: '',
                        showBottonCancel: false,
                        textActionCancel: '',
                        textAction: 'Cerrar'
                    };
                    this.messageResponse(options);
                    return;
                }
                this.$window.location = window.__env.envApiServiceBaseUri + '/order/pay-gate?id=' + this.payInfo.pedidos_id;
            }else{

                let options = {
                    title: '',
                    isHtml: true,
                    content: response.message,
                    size: '',
                    showBottonCancel: false,
                    textActionCancel: '',
                    textAction: 'Aceptar'
                };
                this.messageResponse(options);
            }
        });
    }

    openExperienceModal() {
        let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalExperience,
            controller: 'ModalExperienceController',
            controllerAs: 'mdCtrl',
            resolve: {
                orderData: () => this.orderInfo
            }
        });
        modalInstance.result.then((value) => {

            if(!value.error){
                this.alreadySend = true;
                this.orderInfo["experience_comment"] = value.data.experience_comment;
                this.orderInfo["experience_rating"] = value.data.experience_rating;
            }

            let options = {
                title: '',
                isHtml: false,
                content: value.message,
                size: '',
                showBottonCancel: false,
                textActionCancel: '',
                textAction: 'Aceptar'
            };
            this.messageResponse(options);
        }).catch(reason => {
            console.log(reason);
        });
    }

    messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
        let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalConfirmation,
            controller: 'ModalResponseController',
            controllerAs: 'mdCtrl',
            size: options.size,
            resolve: {
                modalOptions: () => options
            }
        });
        modalInstance.result.then(() => {
            if (callAcept) {
                callback();
            }
        }).catch(reason => {
            if (callCancel) {
                callbackCancel();
            }
        });
    }
}

PayResponseController.$inject = inject;

export default PayResponseController;




/** WEBPACK FOOTER **
 ** ./www/components/response/response.controller.js
 **/